import React, { useEffect, useState } from 'react';
import InformationToolTip from '../InformationToolTip';
import InputLabel from '../InputLabel';
import { withTranslation } from 'react-i18next';
import { Field } from 'formik';
import Switch from '@hobs/components/Switch';

import './CalculateByDays.scss';

const CalculateByDays = ({
  t,
  name,
  component,
  disabled,
  checked,
  setFieldValue,
  indicationMessage,
  differenceInDays,
  isInline,
  children,
  onChange
}) => {
  if (checked === undefined) {
    return null;
  }
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const inlineStyle = isInline ? 'calculate-by-days--inline' : '';

  const onSwitchClick = () => {
    if (!checked) {
      setIsTooltipOpen(true);
      return;
    }
    setIsTooltipOpen(false);
  };

  if (disabled) {
    return (
      <div className={`calculate-by-days ${inlineStyle}`}>
        <div className="calculate-by-days--label">
          <InputLabel indicationMessage={indicationMessage}>
            {t('Calculate by days')}
          </InputLabel>
          <div className="calculate-by-days--tooltip">
            <InformationToolTip
              toolTipInformation={t(
                "'Calculate by days' means that the quantity requested will be ordered for every day during the period. This means that quantity (and price) will be multiplied by the the number of days. Please select 'Calculate by days' to request repeated delivery for every day. Shall only be used for recurring service requests during the selected period."
              )}
              hasMargins={false}
              startDisabled={true}
              isOpen={isTooltipOpen}
              floatRight={false}
            />
          </div>
        </div>
        <div className="calculate-by-days--days">
          <Switch
            disabled
            label={`${
              differenceInDays && checked
                ? differenceInDays + ' ' + t('day(s)')
                : ''
            }`}
            checked={checked}
          >
            {children}
          </Switch>
        </div>
      </div>
    );
  }

  return (
    <div className={`calculate-by-days ${inlineStyle}`}>
      <div className="calculate-by-days--label">
        <InputLabel>{t('Calculate by days') + ':'}</InputLabel>
        <div className="calculate-by-days--tooltip">
          <InformationToolTip
            toolTipInformation={t(
              "'Calculate by days' means that the quantity requested will be ordered for every day during the period. This means that quantity (and price) will be multiplied by the the number of days. Please select 'Calculate by days' to request repeated delivery for every day. Shall only be used for recurring service requests during the selected period."
            )}
            hasMargins={false}
            startDisabled={true}
            isOpen={isTooltipOpen}
            floatRight={false}
          />
        </div>
      </div>
      <div className="calculate-by-days--days">
        <Field
          name={name}
          component={component}
          disabled={disabled}
          checked={checked}
          setFieldValue={setFieldValue}
          indicationMessage={indicationMessage}
          onClick={onSwitchClick}
          onChange={onChange}
        />
        {differenceInDays && checked ? (
          <InputLabel className="calculate-by-days--days-title">
            {`${differenceInDays} ${t(' day(s)')}`}
          </InputLabel>
        ) : null}
      </div>
    </div>
  );
};

CalculateByDays.defaultProps = {
  disabled: false,
  isInline: false,
  onChange: () => {}
};

export default withTranslation()(CalculateByDays);
